import React from "react";
import {
  IonFab,
  IonFabButton,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonSearchbar,
  IonToolbar,
  IonSkeletonText,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import { format } from "date-fns";
import { id as indo } from "date-fns/locale";
import { add } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useFirebase } from "../components/firebase-provider";
import PageLayout from "../components/layout";
import TransactionFinish from "../components/transaction/transaction-finish";

const Transaction: React.FC = () => {
  const [listTransaksi, setListTransaksi] = useState<any>([]);
  const [filter, setFilter] = useState<string>("");

  const { firestore } = useFirebase();
  const [snapshots, loading] = useCollection(
    firestore.collection("transaksi").where("status", "!=", "Selesai")
  );

  useEffect(() => {
    if (snapshots) {
      setListTransaksi(snapshots.docs);
    }
  }, [snapshots]);

  const filterTransaksi = listTransaksi
    .filter(
      (doc: any) =>
        doc?.id.toLowerCase().includes(filter.toLowerCase()) ||
        doc?.data()?.detail?.nama?.toLowerCase().includes(filter.toLowerCase())
    )
    ?.sort(
      (a: any, b: any) =>
        b?.data()?.riwayat[0]?.waktu - a?.data()?.riwayat[0]?.waktu
    );

  const [segment, setSegment] = useState<any>("current");

  const customToolbar = () => (
    <IonToolbar>
      <IonSegment
        color="secondary"
        onIonChange={(e) => setSegment(e.detail.value)}
      >
        <IonSegmentButton value="current">
          <IonLabel>Berjalan ({listTransaksi.length})</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="unpaid">
          <IonLabel>
            Belum Lunas (
            {
              listTransaksi.filter(
                (fltr: any) =>
                  fltr.data()?.pembayaran?.dibayar <
                  fltr.data()?.pembayaran?.total
              ).length
            }
            )
          </IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="finish">
          <IonLabel>Selesai</IonLabel>
        </IonSegmentButton>
      </IonSegment>
    </IonToolbar>
  );

  return (
    <PageLayout title="Transaksi" toolbar={customToolbar()}>
      {segment === "current" && (
        <>
          <IonSearchbar
            value={filter}
            onIonChange={(el) => setFilter(el.detail.value!)}
            className="ion-margin-top"
            mode="ios"
            placeholder="Cari transaksi"
          />
          <IonItemGroup>
            <IonItemDivider>
              <IonLabel color='secondary'>Dibuat</IonLabel>
            </IonItemDivider>
            {loading && (
              <IonItem button detail>
                <IonLabel>
                  <IonSkeletonText style={{ width: "12em" }} />
                  <p>
                    <IonSkeletonText style={{ width: "8em" }} />
                  </p>
                </IonLabel>
              </IonItem>
            )}
            {snapshots && !loading && (
              <>
                {filterTransaksi?.filter(
                  (fltr: any) => fltr.data().status === "Dibuat"
                ).length === 0 && (
                  <IonItem>
                    <IonLabel>
                      <p>Tidak ada transaksi yang dibuat</p>
                    </IonLabel>
                  </IonItem>
                )}

                {filterTransaksi
                  ?.filter((fltr: any) => fltr.data().status === "Dibuat")
                  ?.map((trx: any) => {
                    const data = trx.data();

                    return (
                      <React.Fragment key={trx.id}>
                        <IonItem
                          button
                          detail
                          routerLink={"/app/transaction/view/" + data.id}
                        >
                          <IonLabel>
                            Transaksi {data.id}
                            <p>
                              Dipesan oleh {data.detail.nama} pada{" "}
                              {format(
                                data.riwayat[0].waktu.toDate(),
                                "dd MMMM yyyy",
                                {
                                  locale: indo,
                                }
                              )}
                            </p>
                          </IonLabel>
                        </IonItem>
                      </React.Fragment>
                    );
                  })}
              </>
            )}

            <IonItemDivider>
            <IonLabel color='secondary'>Dibayar</IonLabel>
            </IonItemDivider>
            {loading && (
              <IonItem button detail>
                <IonLabel>
                  <IonSkeletonText style={{ width: "12em" }} />
                  <p>
                    <IonSkeletonText style={{ width: "8em" }} />
                  </p>
                </IonLabel>
              </IonItem>
            )}

            {snapshots && !loading && (
              <>
                {filterTransaksi?.filter(
                  (fltr: any) => fltr.data().status === "Dibayar"
                ).length === 0 && (
                  <IonItem>
                    <IonLabel>
                      <p>Tidak ada transaksi yang dibayar</p>
                    </IonLabel>
                  </IonItem>
                )}

                {filterTransaksi
                  ?.filter((fltr: any) => fltr.data().status === "Dibayar")
                  ?.map((trx: any) => {
                    const data = trx.data();

                    return (
                      <React.Fragment key={trx.id}>
                        <IonItem
                          button
                          detail
                          routerLink={"/app/transaction/view/" + data.id}
                        >
                          <IonLabel>
                            Transaksi {data.id}
                            <p>
                              Dipesan {data.detail.nama} pada{" "}
                              {format(
                                data.riwayat[0].waktu.toDate(),
                                "dd MMMM yyyy",
                                {
                                  locale: indo,
                                }
                              )}
                            </p>
                          </IonLabel>
                        </IonItem>
                      </React.Fragment>
                    );
                  })}
              </>
            )}

            <IonItemDivider>
            <IonLabel color='secondary'>Diproses</IonLabel>
            </IonItemDivider>
            {loading && (
              <IonItem button detail>
                <IonLabel>
                  <IonSkeletonText style={{ width: "12em" }} />
                  <p>
                    <IonSkeletonText style={{ width: "8em" }} />
                  </p>
                </IonLabel>
              </IonItem>
            )}

            {snapshots && !loading && (
              <>
                {filterTransaksi?.filter(
                  (fltr: any) => fltr.data().status === "Diproses"
                ).length === 0 && (
                  <IonItem>
                    <IonLabel>
                      <p>Tidak ada transaksi yang diproses</p>
                    </IonLabel>
                  </IonItem>
                )}

                {filterTransaksi
                  ?.filter((fltr: any) => fltr.data().status === "Diproses")
                  ?.map((trx: any) => {
                    const data = trx.data();

                    return (
                      <React.Fragment key={trx.id}>
                        <IonItem
                          button
                          detail
                          routerLink={"/app/transaction/view/" + data.id}
                        >
                          <IonLabel>
                            Transaksi {data.id}
                            <p>
                              Dipesan {data.detail.nama} pada{" "}
                              {format(
                                data.riwayat[0].waktu.toDate(),
                                "dd MMMM yyyy",
                                {
                                  locale: indo,
                                }
                              )}
                            </p>
                          </IonLabel>
                        </IonItem>
                      </React.Fragment>
                    );
                  })}
              </>
            )}

            <IonItemDivider>
            <IonLabel color='secondary'>Siap</IonLabel>
            </IonItemDivider>
            {loading && (
              <IonItem button detail>
                <IonLabel>
                  <IonSkeletonText style={{ width: "12em" }} />
                  <p>
                    <IonSkeletonText style={{ width: "8em" }} />
                  </p>
                </IonLabel>
              </IonItem>
            )}

            {snapshots && !loading && (
              <>
                {filterTransaksi?.filter(
                  (fltr: any) => fltr.data().status === "Siap"
                ).length === 0 && (
                  <IonItem>
                    <IonLabel>
                      <p>Tidak ada transaksi yang siap</p>
                    </IonLabel>
                  </IonItem>
                )}

                {filterTransaksi
                  ?.filter((fltr: any) => fltr.data().status === "Siap")
                  ?.map((trx: any) => {
                    const data = trx.data();

                    return (
                      <React.Fragment key={trx.id}>
                        <IonItem
                          button
                          detail
                          routerLink={"/app/transaction/view/" + data.id}
                        >
                          <IonLabel>
                            Transaksi {data.id}
                            <p>
                              Dipesan {data.detail.nama} pada{" "}
                              {format(
                                data.riwayat[0].waktu.toDate(),
                                "dd MMMM yyyy",
                                {
                                  locale: indo,
                                }
                              )}
                            </p>
                          </IonLabel>
                        </IonItem>
                      </React.Fragment>
                    );
                  })}
              </>
            )}

            <IonItemDivider>
            <IonLabel color='secondary'>Dikirim</IonLabel>
            </IonItemDivider>

            {loading && (
              <IonItem button detail>
                <IonLabel>
                  <IonSkeletonText style={{ width: "12em" }} />
                  <p>
                    <IonSkeletonText style={{ width: "8em" }} />
                  </p>
                </IonLabel>
              </IonItem>
            )}

            {snapshots && !loading && (
              <>
                {filterTransaksi?.filter(
                  (fltr: any) => fltr.data().status === "Dikirim"
                ).length === 0 && (
                  <IonItem>
                    <IonLabel>
                      <p>Tidak ada transaksi yang sedang dikirim</p>
                    </IonLabel>
                  </IonItem>
                )}

                {filterTransaksi
                  ?.filter((fltr: any) => fltr.data().status === "Dikirim")
                  ?.map((trx: any) => {
                    const data = trx.data();

                    return (
                      <React.Fragment key={trx.id}>
                        <IonItem
                          button
                          detail
                          routerLink={"/app/transaction/view/" + data.id}
                        >
                          <IonLabel>
                            Transaksi {data.id}
                            <p>
                              Dipesan {data.detail.nama} pada{" "}
                              {format(
                                data.riwayat[0].waktu.toDate(),
                                "dd MMMM yyyy",
                                {
                                  locale: indo,
                                }
                              )}
                            </p>
                          </IonLabel>
                        </IonItem>
                      </React.Fragment>
                    );
                  })}
              </>
            )}
          </IonItemGroup>
        </>
      )}

      {segment === "unpaid" && (
        <>
          <IonSearchbar
            value={filter}
            onIonChange={(el) => setFilter(el.detail.value!)}
            className="ion-margin-top"
            mode="ios"
            placeholder="Cari transaksi"
          />
          <IonItemGroup>
            {loading && (
              <IonItem button detail>
                <IonLabel>
                  <IonSkeletonText style={{ width: "12em" }} />
                  <p>
                    <IonSkeletonText style={{ width: "8em" }} />
                  </p>
                </IonLabel>
              </IonItem>
            )}

            {snapshots && !loading && (
              <>
                {filterTransaksi?.filter(
                  (fltr: any) =>
                    fltr.data()?.pembayaran?.dibayar <
                    fltr.data()?.pembayaran?.total
                ).length === 0 && (
                  <IonItem>
                    <IonLabel>
                      <p>Tidak ada transaksi yang belum dibayar</p>
                    </IonLabel>
                  </IonItem>
                )}

                {filterTransaksi
                  ?.filter(
                    (fltr: any) =>
                      fltr.data()?.pembayaran?.dibayar <
                      fltr.data()?.pembayaran?.total
                  )
                  ?.map((trx: any) => {
                    const data = trx.data();

                    return (
                      <React.Fragment key={trx.id}>
                        <IonItem
                          button
                          detail
                          routerLink={"/app/transaction/view/" + data.id}
                        >
                          <IonLabel>
                            Transaksi {data.id}
                            <p>
                              Dipesan {data.detail.nama} pada{" "}
                              {format(
                                data.riwayat[0].waktu.toDate(),
                                "dd MMMM yyyy",
                                {
                                  locale: indo,
                                }
                              )}
                            </p>
                          </IonLabel>
                        </IonItem>
                      </React.Fragment>
                    );
                  })}
              </>
            )}
          </IonItemGroup>
        </>
      )}

      {segment === "finish" && <TransactionFinish />}
      <IonFab horizontal="end" vertical="bottom" slot="fixed">
        <IonFabButton color="secondary" routerLink="/app/transaction/new">
          <IonIcon icon={add} title="Buat transaksi baru" />
        </IonFabButton>
      </IonFab>
    </PageLayout>
  );
};

// const Transaction: React.FC = ()=>(
//   <IonRouterOutlet>
//     <Route path='/transaction' exact component={TransactionPage}/>
//     <Route path='/transaction/new' exact component={NewTransaction}/>
//   </IonRouterOutlet>
// )

export default Transaction;
